/**
 * 위시리스트 카드에 브랜드명 표시 (카트 드로어 패턴 차용)
 *
 * Swym 위시리스트 드로어가 렌더한 각 카드의 상품명 바로 위에
 * brand 라벨(<span class="cart-item__brand">)을 inject. 카트 드로어와
 * 동일 클래스를 써서 디자인시스템 스타일 자동 일관.
 *
 * 데이터 소스 (우선순위):
 *   1. localStorage['swym-products'][i].bt (Swym 캐시 — vendor 스냅샷)
 *   2. /products/<handle>.js fetch (bt 가 비어있거나 새로 담은 직후일 때)
 *
 * 폴백 이유: 위시리스트에 새로 담은 직후 Swym 이 item 은 즉시 추가하지만
 * bt 필드는 cloud sync 후에 채움 → 새로고침 없이 첫 진입 시 bt 비어있을 수 있음.
 * 그 경우 product.vendor 직접 fetch 해서 보강 (한 번만 fetch + 메모리 캐시).
 *
 * 가드:
 *   - dataset.brandInjected 플래그로 중복 inject 방지
 *   - fetch 결과 in-memory 캐시 (같은 handle 재호출 X)
 *   - typeof + try/catch — Swym DOM 변경 시 silent fallback
 */
(function () {
  'use strict';

  const CARD_SELECTOR = 'swym-storefront-layout-item[data-empi]';
  const TITLE_SELECTOR = 'a.swym-storefront-layout-grid-item-title';
  const BRAND_CLASS = 'cart-item__brand';

  const vendorCache = new Map();
  const inflight = new Map();
  let itemsCache = null;

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function () {
    observeCards();
  });

  function observeCards() {
    let scheduled = false;
    const tryInjectAll = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        itemsCache = null;
        document.querySelectorAll(CARD_SELECTOR).forEach(injectBrand);
      });
    };
    const observer = new MutationObserver(tryInjectAll);
    observer.observe(document.body, { childList: true, subtree: true });
    tryInjectAll();
  }

  async function injectBrand(card) {
    if (!card || card.dataset.brandInjected) return;
    const empi = card.dataset.empi;
    if (!empi) return;

    const titleEl = card.querySelector(TITLE_SELECTOR);
    if (!titleEl || !titleEl.parentNode) return;
    if (titleEl.previousElementSibling?.classList?.contains(BRAND_CLASS)) {
      card.dataset.brandInjected = '1';
      return;
    }

    const brand = await resolveBrand(empi, card);
    if (!brand) return;

    if (card.dataset.brandInjected || titleEl.previousElementSibling?.classList?.contains(BRAND_CLASS)) {
      return;
    }

    const span = document.createElement('span');
    span.className = BRAND_CLASS;
    span.textContent = brand;
    titleEl.parentNode.insertBefore(span, titleEl);
    card.dataset.brandInjected = '1';
  }

  async function resolveBrand(empi, card) {
    const item = lookupItem(empi);
    if (item && typeof item.bt === 'string' && item.bt.trim()) {
      return item.bt.trim();
    }
    const handle = extractHandle(card.dataset.du || item?.du);
    if (!handle) return null;
    return await fetchVendor(handle);
  }

  function lookupItem(empi) {
    if (itemsCache === null) {
      try {
        const raw = localStorage.getItem('swym-products');
        itemsCache = raw ? (JSON.parse(raw).all || []) : [];
      } catch (e) {
        itemsCache = [];
      }
    }
    return itemsCache.find((it) => String(it.empi) === String(empi)) || null;
  }

  function extractHandle(du) {
    if (!du || typeof du !== 'string') return null;
    const m = du.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  async function fetchVendor(handle) {
    if (vendorCache.has(handle)) return vendorCache.get(handle);
    if (inflight.has(handle)) return inflight.get(handle);

    const p = (async () => {
      try {
        const res = await fetch(MISTO.localeUrl(`/products/${encodeURIComponent(handle)}.js`));
        if (!res.ok) return null;
        const data = await res.json();
        const v = typeof data.vendor === 'string' && data.vendor.trim() ? data.vendor.trim() : null;
        vendorCache.set(handle, v);
        return v;
      } catch (e) {
        return null;
      } finally {
        inflight.delete(handle);
      }
    })();
    inflight.set(handle, p);
    return p;
  }
})();
